module.exports = __webpack_public_path__ + "static/media/IMG_2598.e963c237.jpg";